import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
Vue.config.productionTip = false
import "./assets/css/every.css"
import "amfe-flexible"
import { i18n } from './i18n/index.js';
import store from './store'
import Vant from "vant"
import "vant/lib/index.css"
import "@/assets/icon/iconfont.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import DOMPurify from 'dompurify';
// import $ from 'jquery'
// Vue.prototype.$ = $

Vue.prototype.imgurl1 = process.env.VUE_APP_IMGURL1
Vue.prototype.imgurl2 = process.env.VUE_APP_IMGURL2
// 作者名兜底脱敏：后端历史数据里部分 authorName 实为作者邮箱，仅显示 @ 前本地部分，
// 避免完整邮箱被爬虫采集（根治需后端清洗 penName）。真实笔名不受影响。
Vue.filter('maskAuthor', (v) => {
  if (v === undefined || v === null) return v
  const s = String(v)
  const at = s.indexOf('@')
  if (at > 0 && /^\S+@\S+\.\S+$/.test(s)) return s.slice(0, at)
  return s
})
// 分类名兜底翻译：书籍 catName 是一套中文旧分类，与英文界面不符。映射命中则译为英文，
// 未命中（已是英文）原样返回。根治需后端统一返回英文分类。
const CAT_NAME_MAP = {
  '玄幻奇幻': 'Xuanhuan & Fantasy', '都市言情': 'Urban Romance', '女生频道': 'Female Channel',
  '男生频道': 'Male Channel', '科幻灵异': 'Sci-Fi & Supernatural', '武侠仙侠': 'Wuxia & Xianxia',
  '历史军事': 'History & Military', '历史': 'History', '网游竞技': 'Games & Esports',
  '网游': 'Games', '游戏': 'Games', '现实': 'Realistic', '恐怖灵异': 'Horror', '二次元': 'ACG',
  '体育': 'Sports', '科幻': 'Sci-Fi', '奇幻': 'Fantasy', '悬疑': 'Suspense', '青春': 'Teen',
  '都市': 'Urban', '言情': 'Romance', '仙侠': 'Xianxia', '武侠': 'Wuxia',
}
Vue.filter('catNameEn', (v) => {
  if (v === undefined || v === null) return v
  const s = String(v).trim()
  return CAT_NAME_MAP[s] || v
})
// 全局 v-safe-html：用 DOMPurify 消毒后再注入 HTML，替代危险的 v-html。
// 用于展示后端富文本（bookDesc / AI 描述 / 新闻等，可能含作者注入内容）→ 阻断存量 XSS→token 窃取链。
// 注意：编辑器/contenteditable 编辑面不要用本指令（会破坏编辑）。
const sanitizeHtml = (v) => DOMPurify.sanitize(v == null ? '' : String(v))
Vue.directive('safe-html', {
  inserted(el, binding) { el.innerHTML = sanitizeHtml(binding.value) },
  update(el, binding) {
    if (binding.value !== binding.oldValue) el.innerHTML = sanitizeHtml(binding.value)
  },
})
Vue.use(Vant);
Vue.use(ElementUI);
import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload) // 注册方式一，使用默认配置
Vue.use(VueLazyload, {
  preload: 1.5, // 表示lazyload元素距离底部距离百分比
  loading: require('@/images/default-cover.jpg'), // 正在加载时显示的图片路径
  error: require('@/images/default-cover.jpg'), // 图片加载失败时显示的图片路径
  attempt: 3, // 图片加载失败后重试次数，默认3
})
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "G-XPE65LPVCV" }
});

import * as voicePromptFun from './utils/voicePrompt'
Vue.prototype.voicePrompt = voicePromptFun.voicePrompt  //语音提醒
const originalPush = VueRouter.prototype.push
// 重写原型上的push方法，统一处理错误信息
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
import { ensureVisitor } from '@/utils/uuid_token'
// 先确保访客会话(uuidtoken)就绪再挂载：这样首个路由守卫/接口调用就能以游客身份通过，
// 不会因 token 未注册而把游客误判为未登录、弹去 /login。
// 已访问过的用户 localStorage 已有 uuidtoken → ensureVisitor 立即返回，无额外网络开销。
ensureVisitor().finally(() => {
  new Vue({
    router,
    store,
    i18n,
    // el: '#app',
    render: h => h(App),
  }).$mount('#app')
})


// 全局禁用 console.log 输出
if (process.env.NODE_ENV !== 'development') {
  console.log = () => {}
  // 全局禁用F12
  window.addEventListener('keydown', event => {
    // 禁用F12键
    if (event.key === 'F12') {
      event.preventDefault()
    }
  })
}

